import type { GetAssetByIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetAssetByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAssetByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetAssetByIdArgs = {
  id: string;
};

export const useLazyGetAssetById = createLazyQueryHook<
  UseLazyGetAssetByIdArgs,
  GetAssetByIdResponseRow[],
  GetAssetByIdQuery
>({
  trpcQuery: (client, { id }) => client.frontend.asset.assetById.query({ id }),
  mapTrpcDataToGraphQL: (data) => ({ asset: data }),
  graphqlDocument: GetAssetByIdDocument,
  graphqlVariables: ({ id }) => ({ _eq: id }),
});
